import { useMemo } from 'react'
import { PRESCRIPTION_LAYOUTS } from 'src/consumer/constants'
import { PmpHeaderContainer } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'
import DefaultPrescriptionHeader from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/header/DefaultPrescriptionHeader'
import ListPointersFooterPrescriptionHeader from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/header/ListPointersFooterPrescriptionHeader'
import ManasthanPrescriptionHeader from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/header/ManasthanPrescriptionHeader'
import MultipleTemplateHeadersPrintableComponent from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/header/MultipleTemplateHeadersPrintableComponent'
import TwoColumnFooterWithDisclaimerHeaderWithDegreesInSeperateLines from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/header/TwoColumnFooterWithDisclaimerHeaderWithDegreesInSeperateLines'
import TwoColumnPrescriptionHeader from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/header/TwoColumnPrescriptionHeader'
import TwoDoctorHeader from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/header/TwoDoctorHeader'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'

export default function PrescriptionPrintableHeader({
  headerStyleToShow,
  prescriptionData,
  headerHeight,
  currentPage,
  printType,
  debugMode,
  hideDebugLabels,
  pageHeight,
  headerDimensionsHeight,
  showBottomBorder,
  idx,
  leaveSpace,
  useFullUrlForHeaderImages,
}) {
  return (
    <PrescriptionHeaderRender
      prescriptionData={prescriptionData}
      leaveSpace={leaveSpace}
      debug={debugMode}
      printType={printType}
      headerHeight={headerHeight}
      useCompleteImageLink={useFullUrlForHeaderImages}
    />
  )
}

export const PrescriptionHeaderRender = ({
  prescriptionData,
  leaveSpace,
  debug = false,
  printType,
  headerHeight = 'unset',
  useCompleteImageLink = false,
}) => {
  const HeaderComponent = useMemo(() => {
    switch (prescriptionData?.layout) {
      case PRESCRIPTION_LAYOUTS.threeColumnFooter:
      case PRESCRIPTION_LAYOUTS.twoColumnFooter:
        return TwoColumnPrescriptionHeader
      case PRESCRIPTION_LAYOUTS.twoColumnWithDisclaimerFooterWithDegreesInSeperateLines:
        return TwoColumnFooterWithDisclaimerHeaderWithDegreesInSeperateLines
      case PRESCRIPTION_LAYOUTS.listPointersFooter:
      case PRESCRIPTION_LAYOUTS.boxHeaderWithTwoColumnFooter:
        return ListPointersFooterPrescriptionHeader
      case PRESCRIPTION_LAYOUTS.twoDoctorHeader:
      case PRESCRIPTION_LAYOUTS.twoDoctorHeaderWithListPointers:
        return TwoDoctorHeader
      case PRESCRIPTION_LAYOUTS.manasthan:
        return ManasthanPrescriptionHeader
      default:
        return DefaultPrescriptionHeader
    }
  }, [prescriptionData?.layout])

  return (
    <>
      <PmpHeaderContainer
        data-print-header="true"
        style={{ height: headerHeight }}
        headerHeight={headerHeight}
        debug={debug}
      >
        {!Boolean(leaveSpace) && (
          <>
            {!prescriptionData?.header?.imageId ? (
              <HeaderComponent
                topPadding={
                  prescriptionData?.layout === PRESCRIPTION_LAYOUTS.listPointersFooter
                    ? '10px'
                    : undefined
                }
                prescriptionData={prescriptionData}
                debug={debug}
              />
            ) : (
              // Give the wrapper the header box's height so the image's `height: 100%`
              // actually resolves, and use object-fit: contain so the full letterhead
              // always fits inside the fixed-height, overflow-hidden header box instead
              // of being sized by width alone (which makes it taller than the box at full
              // A4 print width and gets the bottom band clipped — showing white).
              <div style={{ height: '100%' }}>
                <img
                  style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
                  src={
                    useCompleteImageLink
                      ? prescriptionData?.header?.imageId
                      : getImageLink(prescriptionData?.header?.imageId)
                  }
                  alt="Header"
                  crossOrigin="anonymous"
                />
              </div>
            )}
          </>
        )}
        {leaveSpace && (() => {
          // Ensure we have a valid height - use headerHeight if it's a positive number, otherwise fallback to 120px
          const actualHeight = (typeof headerHeight === 'number' && headerHeight > 0) 
            ? headerHeight 
            : (typeof headerHeight === 'string' && headerHeight && headerHeight !== 'unset' && headerHeight !== '0px' && headerHeight !== '0')
              ? headerHeight
              : 120 // Fallback to 120px if headerHeight is 0, undefined, or invalid
          const heightStr = typeof actualHeight === 'number' ? `${actualHeight}px` : actualHeight
          
          return (
            <div 
              className="blank-header-space" 
              style={{ 
                height: heightStr, 
                minHeight: heightStr, 
                maxHeight: heightStr,
                width: '100%',
                display: 'block', 
                visibility: 'visible', 
                boxSizing: 'border-box', 
                flexShrink: 0,
                flexGrow: 0,
                flex: `0 0 ${heightStr}`,
                backgroundColor: 'transparent',
                border: '1px solid transparent',
                outline: 'none',
                margin: 0,
                padding: 0,
                overflow: 'hidden',
                position: 'relative',
              }}
              aria-hidden="true"
              data-header-height={typeof actualHeight === 'number' ? actualHeight : parseFloat(actualHeight) || 120}
            >
              {/* Invisible spacer with non-breaking space to prevent collapse - this ensures the div has content */}
              <span style={{ 
                display: 'inline-block', 
                height: heightStr, 
                width: '1px', 
                opacity: 0, 
                visibility: 'hidden', 
                position: 'absolute', 
                fontSize: '1px', 
                lineHeight: heightStr
              }}>&#8203;</span>
            </div>
          )
        })()}
        <MultipleTemplateHeadersPrintableComponent
          prescriptionData={prescriptionData}
          debug={debug}
        />
      </PmpHeaderContainer>
    </>
  )
}

// return (
//   <>
//     {headerStyleToShow === HEADER_TYPES?.onAllPages ? (
//       <div style={{ borderBottom: showBottomBorder ? '1px solid #000' : 'unset' }}>

//         {debugMode && !hideDebugLabels ? (
//           <div
//             style={{
//               position: 'absolute',
//               top: `${pageHeight * (currentPage - 1) + headerDimensionsHeight - 10}px`,
//               right: '0px',
//             }}
//           >
//             HEADER ENDS AND BODY STARTS: {headerDimensionsHeight?.toFixed(2)} Px
//           </div>
//         ) : (
//           <></>
//         )}
//       </div>
//     ) : (
//       <></>
//     )}
//     {headerStyleToShow === HEADER_TYPES?.onAlternatePages ? (
//       <>
//         {idx % 2 === 0 ? (
//           <div style={{ borderBottom: showBottomBorder ? '1px solid #000' : 'unset' }}>
//             <PrescriptionHeader
//               prescriptionData={prescriptionData}
//               leaveSpace={printType === PRESCRIPTION_PRINT_TYPES.withHeaderAndFooterBlankSpace}
//               headerHeight={headerHeight}
//               debug={debugMode}
//               printType={printType}
//             />
//             {debugMode && !hideDebugLabels ? (
//               <div
//                 style={{
//                   position: 'absolute',
//                   top: `${pageHeight * idx + headerDimensionsHeight - 10}px`,
//                   right: '0px',
//                 }}
//               >
//                 HEADER ENDS AND BODY STARTS: {headerDimensionsHeight?.toFixed(2)} Px
//               </div>
//             ) : (
//               <></>
//             )}
//           </div>
//         ) : (
//           <>
//             {debugMode && !hideDebugLabels ? (
//               <div
//                 style={{
//                   position: 'absolute',
//                   top: `${pageHeight * idx + 30}px`,
//                   right: '0px',
//                 }}
//               >
//                 HEADER ENDS AND BODY STARTS: 0 Px
//               </div>
//             ) : (
//               <></>
//             )}
//           </>
//         )}
//       </>
//     ) : (
//       <></>
//     )}
//     {headerStyleToShow === HEADER_TYPES?.blankHeader ? (
//       <div style={{ borderBottom: showBottomBorder ? '1px solid #000' : 'unset' }}>
//         <PrescriptionHeader
//           prescriptionData={prescriptionData}
//           leaveSpace={true}
//           headerHeight={headerHeight}
//           debug={debugMode}
//           printType={printType}
//         />
//         {debugMode && !hideDebugLabels ? (
//           <div
//             style={{
//               position: 'absolute',
//               top: `${pageHeight * idx + headerDimensionsHeight - 10}px`,
//               right: '0px',
//             }}
//           >
//             HEADER ENDS AND BODY STARTS: {headerDimensionsHeight?.toFixed(2)} Px
//           </div>
//         ) : (
//           <></>
//         )}
//       </div>
//     ) : (
//       <></>
//     )}
//     {debugMode && !hideDebugLabels ? (
//       <div
//         style={{
//           position: 'absolute',
//           // top: `${
//           //   heightOfPageMeasureComponent -
//           //   (headerDimensions?.height + footerDimensions?.height) -
//           //   10
//           // }px`,
//           top: `${pageHeight * idx - 10}px`,
//           right: '0px',
//         }}
//       >
//         Page {idx + 1} ends {headerDimensionsHeight?.toFixed(2)}px
//       </div>
//     ) : (
//       <></>
//     )}
//   </>
// )
